module.exports = __webpack_public_path__ + "static/media/gasnet32_2.4619cfc7.gif";